import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import LoadingScreen from './LoadingScreen';
import StatsShell from './stats/StatsShell';
import { colors } from '../theme';

/**
 * Thin wrapper: resolves the client's active program (needed by the
 * Overview tab's weekly-target ring) and renders the outer back-button
 * chrome, then hands off to StatsShell for the 4-tab Stats experience.
 * All tab content/logic now lives under src/components/stats/.
 */
const EnhancedStats = ({ userId, onBack, initialTab }) => {
  const [loading, setLoading] = useState(true);
  const [programId, setProgramId] = useState(null);

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;

    const resolveProgramId = async () => {
      setLoading(true);
      try {
        const { data: assignment } = await supabase
          .from('program_assignments')
          .select('program_id')
          .eq('user_id', userId)
          .eq('is_active', true)
          .maybeSingle();

        if (assignment) {
          if (!cancelled) setProgramId(assignment.program_id);
        } else {
          const { data: fallbackProgram } = await supabase
            .from('programs')
            .select('id')
            .eq('user_id', userId)
            .eq('is_client_copy', false)
            .maybeSingle();
          if (!cancelled && fallbackProgram) setProgramId(fallbackProgram.id);
        }
      } catch (error) {
        console.error('Error resolving active program:', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    resolveProgramId();
    return () => { cancelled = true; };
  }, [userId]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div style={styles.container}>
      {onBack && (
        <button onClick={onBack} style={styles.backBtn}>
          ← Back
        </button>
      )}
      <StatsShell userId={userId} programId={programId} onStartWorkout={onBack} initialTab={initialTab} />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: colors.bg,
    minHeight: '100vh',
    padding: '20px',
  },
  backBtn: {
    marginBottom: '16px',
    padding: '10px 16px',
    background: colors.surface1,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    color: colors.text,
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default EnhancedStats;
